import { IconExpandLessMS, IconExpandMoreMS } from '@/constants/icons';
import { MouseEvent, useCallback, useEffect, useRef, useState } from 'react';

import { ExpandButton, ReasonContainer, ReasonText } from './styles';

interface ReasonAccordionProps {
  reason: string;
}

export function ReasonAccordion({ reason }: ReasonAccordionProps): JSX.Element {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const reasonRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const element = reasonRef.current;

    if (!element || isExpanded) return undefined;

    const checkTruncation = (): void =>
      setIsTruncated(element.scrollWidth > element.clientWidth);

    checkTruncation();

    const observer = new ResizeObserver(checkTruncation);
    observer.observe(element);

    return () => observer.disconnect();
  }, [reason, isExpanded]);

  const handleToggle = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setIsExpanded((prevExpanded) => !prevExpanded);
  }, []);

  if (!reason) return <span>-</span>;

  return (
    <ReasonContainer>
      <ReasonText ref={reasonRef} isExpanded={isExpanded}>
        {reason}
      </ReasonText>

      {(isTruncated || isExpanded) && (
        <ExpandButton
          type="button"
          onClick={handleToggle}
          aria-expanded={isExpanded}
          aria-label={isExpanded ? 'Recolher motivo' : 'Ver motivo completo'}
          title={isExpanded ? 'Recolher motivo' : 'Ver motivo completo'}
        >
          {isExpanded ? IconExpandLessMS : IconExpandMoreMS}
        </ExpandButton>
      )}
    </ReasonContainer>
  );
}
